import IconFA from './IconFA';

export {IconFA};
